import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ALERT_MESSAGE, AlertService } from '@core/alert/alert.service';
import { AuthService } from '@core/auth.service';
import { SEGMENT } from '@root/app-routing.model';
import { AppConfig } from '@root/app.config';
import { UNAUTHORIZED } from 'http-status-codes';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	constructor(
		private readonly router: Router,
		private readonly appConfig: AppConfig,
		private readonly injector: Injector,
	) { }

	private getToken() {
		return this.injector.get(AuthService, null)?.getToken() || undefined;
	}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.url !== this.appConfig.getConfigLocation()) {
			const localStorageToken: string | undefined = this.getToken();
			const queryParamToken: string | null = request.params.get('token');
			let headers: HttpHeaders = new HttpHeaders();
			if (localStorageToken && !queryParamToken) {
				headers = headers.set('Authorization', localStorageToken);
			}
			request = request.clone({ headers });
		}
		return next.handle(request).pipe(
			catchError(error => {
				if (error instanceof HttpErrorResponse) {
					if (error.status === UNAUTHORIZED) {
						const alertService: AlertService = this.injector.get(AlertService);
						alertService.addMessage(
							ALERT_MESSAGE.DANGER,
							marker('tachomat.common.error.not-authorized'),
							true
						);
						this.router.navigate([SEGMENT.REMOVE_CARD]);
					}
				}
				throw error;
			})
		);
	}
}
